<template>
    <div class="container">
        <h1 class="title">
            Profitable Recipes
        </h1>
        <h2 class="subtitle">
            A list of recipes that can be used to gain instant gold
        </h2>
        <div class="columns">
            <div class="column" v-if="instantBuyShown">
                <div class="box">
                    <h3 class="title is-4">Instant Buy</h3>
                    <p>
                        Recipes where you gain gold by instantly buying
                        materials from sell orders on the Trading Post,
                        crafting an item and immediately selling it.
                    </p>
                    <br>
                    <router-link to="/shinies/recipes/instant"><span class="icon is-inline"><i class="fas fa-list"></i></span> Recipes</router-link>
                </div>
            </div>
            <div class="column" v-if="buyOrderShown">
                <div class="box">
                    <h3 class="title is-4">Buy Order</h3>
                    <p>
                        A list of recipes where you gain gold by placing a
                        buy order on the Trading Post, then crafting an
                        item and immediately selling it.
                    </p>
                    <br>
                    <router-link to="/shinies/recipes/order"><span class="icon is-inline"><i class="fas fa-list"></i></span> Recipes</router-link>
                </div>
            </div>
        </div>
        <!--
        <div class="columns">
            <div class="column">
                <div class="box">
                    <h3 class="title is-4">Crafting calculator</h3>
                    <p>
                        The tool behind this all - a crafting simulator that
                        calculates how much to craft to make profit or how
                        much will be gained/lost when crafting.
                    </p>
                    <p>
                        Can buy materials with from sell orders or with buy orders,
                        simulates how Trading Post orders are filled while crafting.
                        The only limitation is that the crafting tree is static and
                        does not change depending on the current cheapest path.
                    </p>
                    <br>
                    <router-link to="/shinies/recipes/crafting"><span class="icon is-inline"><i class="fas fa-calculator"></i></span> Crafting calculator</router-link>
                </div>
            </div>
        </div>
        -->
    </div>
</template>

<script>
    export default {
        name: 'recipes-index',
        computed: {
            buyOrderShown() {
                return this.$store.state.permissions.permissions.includes("ShiniesRecipesListBuyOrder");
            },
            instantBuyShown() {
                return this.$store.state.permissions.permissions.includes("ShiniesRecipesListInstantBuy");
            },
        },
    }
</script>
